<template src="./Header.component.html"></template>
<style type="text/css" src="./Header.component.css"></style>

<script>
import Navigation from './../Navigation/Navigation.component'
export default {
  name: 'Header',
  components: {
    'NavigationComponent': Navigation
  },
  data () {
    return {}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Header/Header.component.vue